import React from "react";
import { Nav, NavbarBrand, NavbarToggler, Collapse, NavItem } from "reactstrap";
import { Link } from "react-scroll";
import { Link as Link2 } from "react-router-dom";
import { useAuthenticator } from "@aws-amplify/ui-react";
import * as Icon from "react-feather";

import Logodark from "../assets/images/logo-dark.svg";
import Logolight from "../assets/images/logo-light.svg";

export default function Navbar({ isOpen, toggleMenu, showNavLinks = true }) {
  const { route, signOut, user } = useAuthenticator((context) => [
    context.route,
    context.signOut,
    context.user,
  ]);

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  return (
    <nav
      id="navbar"
      className="navbar navbar-expand-lg nav-light fixed-top sticky"
    >
      <div className="container">
        <NavbarBrand className="navbar-brand" href="/">
          <span className="logo-light-mode">
            <img src={Logodark} className="l-dark w-75" alt="" />
            <img src={Logolight} className="l-light w-75" alt="" />
          </span>
          <img src={Logolight} className="logo-dark-mode w-75" alt="" />
        </NavbarBrand>

        {showNavLinks && (
          <NavbarToggler onClick={toggleMenu}>
            <Icon.Menu />
          </NavbarToggler>
        )}

        <Collapse
          className={`navbar-collapse ${isOpen === true ? "hidden" : "show"}`}
          id="navbarSupportedContent"
        >
          {showNavLinks && (
            <Nav
              className="navbar-nav ms-auto mb-2 mb-lg-0"
              id="navbar-navlist"
            >
              <NavItem>
                <Link
                  activeClass="active"
                  to="home"
                  spy={true}
                  smooth={true}
                  duration={500}
                  className="nav-link"
                >
                  Home
                </Link>
              </NavItem>
              <NavItem>
                <Link
                  activeClass="active"
                  to="service"
                  spy={true}
                  smooth={true}
                  duration={500}
                  className="nav-link"
                >
                  Services
                </Link>
              </NavItem>
              <NavItem>
                <Link
                  activeClass="active"
                  to="project"
                  spy={true}
                  smooth={true}
                  duration={500}
                  className="nav-link"
                >
                  Solutions
                </Link>
              </NavItem>
              {/* <NavItem>
                <Link
                  activeClass="active"
                  to="pricing"
                  spy={true}
                  smooth={true}
                  duration={500}
                  className="nav-link"
                >
                  Pricing
                </Link>
              </NavItem> */}

              <NavItem>
                <Link
                  activeClass="active"
                  to="case-studies"
                  spy={true}
                  smooth={true}
                  duration={500}
                  className="nav-link"
                >
                  Case Studies
                </Link>
              </NavItem>
              <NavItem>
                <Link
                  activeClass="active"
                  to="team"
                  spy={true}
                  smooth={true}
                  duration={500}
                  className="nav-link"
                >
                  Team
                </Link>
              </NavItem>
              <NavItem>
                <Link
                  activeClass="active"
                  className="nav-link"
                  to="contact"
                  spy={true}
                  smooth={true}
                  duration={500}
                >
                  Contact Us
                </Link>
              </NavItem>
            </Nav>
          )}

          {showNavLinks && (
            <ul className="list-inline menu-social mb-0 ps-lg-4 ms-2">
              <li className="list-inline-item">
                {route === "authenticated" ? (
                  <div className="d-flex align-items-center">
                    <button
                      onClick={handleSignOut}
                      className="btn btn-numantra-primary"
                    >
                      Logout
                    </button>
                  </div>
                ) : (
                  <Link2 to="/login" className="btn btn-numantra-primary">
                    Login
                  </Link2>
                )}
              </li>
            </ul>
          )}
        </Collapse>
      </div>
    </nav>
  );
}
